<template>
	<div class="innerBox">
		<h2 class="mb-4">Input Supplier Voucher</h2>

		<div class="row rounded border border-secondary p-10" style="min-height:500px">
			<!-- <div class="col-3">
				<h5>Preview Gambar Faktur Pembayaran :</h5>

				<img :src="url" v-if="url" style="width:100%;height:auto;max-width:100%;"/>
			</div> -->
			<div class="col-12">
				<div class="row mt-4 text-center">
					<div class="col-3 middleDiv">
						<h5>Kategori <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<Multiselect
                            v-model="form.category"
							:options="options.category.map(x => x.code)"
                            :custom-label="opt => options.category.find(x => x.code == opt).name"
                            :allow-empty="false"
							class="w-100"
						/>
					</div>
                </div>

				<div class="row mt-3 text-center" v-if="isRequired('supplier_id')">
					<div class="col-3 middleDiv">
						<h5>Supplier <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<Multiselect
                            v-model="form.supplier_id"
							:options="supplierList.map(x => x.id)"
                            :custom-label="opt => supplierList.find(x => x.id == opt).name"
                            :allow-empty="false"
							class="w-100"
						/>
					</div>
				</div>

				<div v-if="form.category == 'supplier_cat'">
					<SupplierCatTable 
						ref="supplier_cat"
					/>
				</div>

				<div v-if="form.category == 'supplier_part' && pending_payment">

					<!-- <div class="row mt-3 text-center" >
						<div class="col-3 middleDiv">
							<h5>Pilih Sparepart <span class="text-red">*</span></h5>
						</div>
						<div class="col-2 middleDiv">
							<h5>:</h5>
						</div>
						<div class="col-7 text-left" v-if="Object.keys(pending_payment).length > 0">
							<button class="btn btn-primary mb-3 mr-3" @click="clickAll()">Pilih Semuanya</button>
							<button class="btn btn-danger mb-3" @click="reset()">Reset</button>
							<div v-for="keys in Object.keys(pending_payment)" :key="keys" >
								<h5>{{keys}}</h5>
								<div class="ml-3" v-for="(dat , index) in pending_payment[keys]" :key="index">
									<input type="checkbox" :id="`${dat.sparepart_name}  - ${index} - ${dat.part_number}`" v-model="ongoing" :value="dat" style="width: 50px">
									<label :for="'selectBank'+index">
										{{dat.sparepart_name}} - {{dat.part_number}}
									</label>
								</div>
							</div>
						</div>
						<div class="col-7 text-left" v-else>
							<h5>No Pending Sparepart For Supplier.</h5>
						</div>
						
					</div> -->
					
					<div class="display:block;overflow-x:scroll">
						<table class="table mt-3 mb-3 w-100" style="background-color:white;">
							<thead>
								<th>Pilih</th>
								<th>No.</th>
								<th>No Polisi</th>
								<th>Nama Sparepart</th>
								<th>Deskripsi Sparepart</th>
								<!-- <th>Nama Supplier</th> -->
								<th>Jumlah</th>
								<th>Dp</th>
								<th>Harga Total</th>
								<th>Harga Estimasi</th>
								<th>Markup</th>
								<th>Barang Diterima</th>
								<th>Aging</th>
								<th>Gambar</th>
							</thead>

							<tbody>
								<tr v-for="(sparepart, index) in full_pending_payment" :key="ongoing.sparepart_name" :class="{'bg-yellow' : ongoing.find(x => x == sparepart)}" @click="addRemove(sparepart)">
									<td>
										<input type="checkbox" :id="`${sparepart.sparepart_name}  - ${index} - ${sparepart.part_number}`" v-model="ongoing" :value="sparepart" style="width: 50px">
									</td>
									<td>{{index + 1}}</td>
									<td>{{sparepart.registration}}</td>
									<td>{{sparepart.sparepart_name}}</td>
									<td>{{sparepart.part_number}}</td>
									<!-- <td>{{sparepart.name}}</td> -->
									<td>{{sparepart.amount}}</td>
									<td>{{sparepart.dp ? numberWithCommas(sparepart.dp) : 0}}</td>
									<td>{{numberWithCommas(parseFloat(sparepart.amount) * parseFloat(sparepart.price_per_item))}}</td>
									<td>{{numberWithCommas(parseFloat(sparepart.estimation_price))}}</td>
									<td>+ {{ sparepart.markup ? numberWithCommas(sparepart.markup) : 0}}</td>
									<td>{{sparepart.time_of_arrival ? `${moment(sparepart.time_of_arrival).format('MMM DD,YYYY')}` : ''}}</td>
									<td>{{sparepart.aging}}</td>
									<td><button class="btn btn-primary" @click="showImage(sparepart.delivery_photo)"><i class="fa fa-image"></i></button></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div v-else-if="form.category == 'supplier_bahan' && pending_payment_bahan">
					
					<div class="display:block;overflow-x:scroll">
						<table class="table mt-3 mb-3 w-100" style="background-color:white;">
							<thead>
								<th>Pilih</th>
								<th>No.</th>
								<th>Nomor Reference</th>
								<th>Nama Bahan</th>
								<!-- <th>Nama Supplier</th> -->
								<th>Jumlah</th>
								<th>Harga Satuan Barang</th>
								<th>Harga Total</th>
								<th>Waktu Barang Diterima</th>
								<th>Diterima Oleh</th>
								<th class="text-center"><i class="fa fa-cog"></i></th>
								
								<!-- <th>Gambar</th> -->
							</thead>

							<tbody>
								<tr v-for="(sparepart, index) in full_pending_payment_bahan" :key="ongoing.sparepart_name" :class="{'bg-yellow' : ongoing.find(x => x == sparepart)}" @click="addRemove(sparepart)">
									<td>
										<input type="checkbox" :id="`${sparepart.sparepart_name}  - ${index}`" v-model="ongoing" :value="sparepart" style="width: 50px">
									</td>
									<td>{{index + 1}}</td>
									<td>{{sparepart.transaction_id}}</td>
									<td>{{sparepart.sparepart_name}}</td>
									<td>{{numberWithCommas(sparepart.amount)}}</td>
									<td>Rp. {{numberWithCommas(sparepart.price_per_item)}}</td>
									<td>Rp. {{numberWithCommas(parseFloat(sparepart.amount) * parseFloat(sparepart.price_per_item))}}</td>
									<td>{{sparepart.date_received ? `${moment(sparepart.date_received).format('MMM DD,YYYY')}` : ''}}</td>
									<td>{{sparepart.received_by}}</td>
									<td class="text-center">
										<button class="btn btn-danger" @click="cancelBahan(null , sparepart.transaction_id , sparepart.sparepart_id)">Batalkan Pembelian Bahan</button>
									</td>
									<!-- <td>{{sparepart.aging}}</td> -->
									<!-- <td><button class="btn btn-primary" @click="showImage(sparepart.delivery_photo)"><i class="fa fa-image"></i></button></td> -->
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div v-else-if="form.category == 'supplier_jasa'">

					<table class="table text-center mt-4 mb-4">
						<thead>
							<th>No.</th>
							<th>Kode Work Order</th>
							<th>Nama Jasa</th>
							<th>Tgl Pengerjaan</th>
							<th>Harga</th>
						</thead>
						<tbody>
							<template v-if="jasaLength.length > 0">
								<tr v-for="(jasa , index) in jasaLength" :key="index">
									<td>{{index + 1}}</td>
									<td>{{jasa.work_order_code}}</td>
									<td>{{jasa.sparepart_name}}</td>
									<td>{{jasa.tgl_pengerjaan}}</td>
									<td>{{jasa.amount}}</td>
								</tr>
							</template>
							<tr>
								<td colspan="5">
									<h4 style="text-decoration:underline" @click="modal.showAddTPJ = true">Klik Disini Untuk Tambah Jasa</h4>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div v-else-if="form.category == 'supplier_derek'">
					<!--  -->
					<div class="row mt-3 text-center">
						<div class="col-3 middleDiv">
							<h5>Nomor Work Order <span class="text-red">*</span></h5>
						</div>
						<div class="col-2 middleDiv">
							<h5>:</h5>
						</div>
						<div class="col-7">
							<MultiSelect
								class="w-100"
								v-model="form.workorder_code"
								:options="woList.map(x => x.form_code)"
								:custom-label="opt =>woList.find(x => x.form_code == opt).name"
								:close-on-select="true"
								:multiple="false"
								:allow-empty="false"
								:internal-search="false"
								placeholder="Cari Nomor Wo ( Ketik Minimal 3 Kata )"
								@search-change="debouceFunction"
							>
							</MultiSelect>
						</div>
					</div>

					<div class="mt-3 mb-3 text-center" style="color:red">
						<h3>{{warning}}</h3>
					</div>
				</div>
                
				<!-- <div class="row mt-3 text-center" v-if="isRequired('labourer_id')">
					<div class="col-3 middleDiv">
						<h5>Pekerja <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<Multiselect
                            v-model="form.labourer_id"
							:options="options.laborer.map(x => x.id)"
                            :custom-label="opt => options.laborer.find(x => x.id == opt).name"
                            :allow-empty="false"
							class="w-100"
						/>
					</div>
                </div> -->

				<!-- <div class="row mt-3 text-center" v-if="isRequired('description')">
					<div class="col-3 middleDiv">
						<h5>Deskripsi <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<textarea 
							rows="5"
							class="w-100 form-control"
							v-model="form.description"
						/>
					</div>
				</div> -->
                
                
				<div class="row mt-3 text-center" v-if="isRequired('amount')">
					<div class="col-3 middleDiv">
						<h5>Jumlah Uang <span class="text-red">*</span></h5>
					</div>
					<div class="col-2 middleDiv">
						<h5>:</h5>
					</div>
					<div class="col-7">
						<input type="text" disabled v-model="form.amount" class="form-control" style="height: 43px;" placeholder="Ketik Jumlah Uang"/>
					</div>
				</div>
                <!-- AMOUNT, SALARY, OVERTIME, BONUS, ENDS -->
                
                <div class="row">
                    <div class="col-7 offset-6">
                        <!-- <p class="text-red m-0">* Harus di-isi</p> -->
                        <p class="text-orange m-0" v-if="form.category == 'labourer_wage'">** Isi 0 jika tidak ada</p>
                    </div>
                </div>

				<div class="row mt-4">
					
					<div class="offset-6 col-3">
						
						<button class="btn btn-danger w-100" @click="$router.push({ name : 'SupplierVoucher'})">Batal</button>
					</div>
					<div class="col-3" >
						<button class="btn btn-primary w-100" :disabled="warning" @click="submit">Selesai</button>
					</div>
				</div>
			</div>
		</div>

		<preview-image
			v-if="modal.showImage"
			@closeModal="modal.showImage = false"
			:title="'Gampar Sparepart'"
			:image="imagesList"
		></preview-image>

		<addTPJ 
			v-if="modal.showAddTPJ"
			@closeModal="modal.showAddTPJ = false"
			@addSparepartToTable="addJasa"
		/>
		<adminAuth
			v-if="modal.showAdminAuth"
			@closeModal="modal.showAdminAuth = false"
			:reason="reason"
			:request="
				`Pembatalan Bahan Transaksi ${temp.transaction_id} Untuk Sparepart ID ${temp.sparepart_id}`
			"
			@approved="allowCancelBahan"
			@token="cancelBahan"
		/>

		
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import previewImage from '@/components/modal/previewImage'
import addTPJ from './addTPJ.vue'
import env from '@/env'
import debounce from 'debounce'
import adminAuth from "@/components/modal/adminAuthorization";
import SupplierCatTable from './supplierCatTable.vue'
export default {
	components : {
		Multiselect,
		previewImage,
		addTPJ,
		adminAuth,
		SupplierCatTable
	},
	data () {
		return {
            moment : moment,
            numberFields : ['salary', 'overtime', 'bonus', 'amount'],
            requiredFields : {
                supplier_part : ['category', 'supplier_id', 'amount'],
				supplier_bahan : ['category', 'supplier_id', 'amount'],
				supplier_jasa : ['category' , 'supplier_id' , 'amount'],
				supplier_derek : ['category' , 'supplier_id' , 'amount'],
				supplier_cat : ['cat_brand_id']
            },
			modal : {
				showImage : false,
				showAddTPJ : false,
				showAdminAuth : false
			},
			imagesList : null,
			form : {
                category : 'supplier_part',
                workorder_code : '',
                sparepart_id : '',
                supplier_id : '',
                labourer_id : '',
                description : '',
                month : moment().month(),
                year : moment().year(),

                amount : '',
                salary : '',
                overtime : '',
                bonus : '',
                value_payable : '',

                proof_img : '',
            },
            options : {
                category : [
                    {code : 'supplier_part', name : 'Supplier Part'},
					{code : 'supplier_bahan', name : 'Supplier Bahan'},
					{code : 'supplier_jasa', name : 'Supplier Jasa'},
					{code : 'supplier_derek', name : 'Supplier Derek'},
					{code : 'supplier_cat', name : 'Supplier Cat'},
                ],
                workorder : [],
                sparepart : [],
                supplier : this.$store.getters.getSupplier,
                laborer : this.$store.getters.getLaborer,
                month : this.$store.getters.getMonth,
                year : this.$store.getters.getYear,
            },
			file : null,
			url : null,
			fileError : '',
			labourerList : null,
			pending_payment : null,
			pending_payment_bahan : null,
			full_pending_payment : null,
			full_pending_payment_bahan : null,
			ongoing : [], 
			supplierList : [],
			showPendingBahan : {},
			jasaLength : [],
			woList : [],
			debouceFunction : null,
			warning : null,
			temp : {
				transaction_id : null,
				sparepart_id : null
			}
		}
    },
	watch : {
		'form.category' : function () {
			this.pending_payment = null
			this.ongoing = []
			this.loadSupplierList()
			this.jasaLength.length = 0;
			this.warning = null
		},
		'form.amount' : function () {
			const result = this.form.amount.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(() => this.form.amount = result);
        },
		'form.supplier_id' : function () {
			if(this.pending_payment)
				this.$set(this , 'pending_payment' , null)
			
			if(this.ongoing)
				this.$set(this , 'ongoing' , [])
			
			if(this.form.category == 'supplier_part') {
				if(!this.form.supplier_id)
					return
				this.loadVoucher(this.form.supplier_id)
			}
			else if (this.form.category == 'supplier_bahan') {
				if(!this.form.supplier_id)
					return
				this.loadVoucherBahan(this.form.supplier_id)
			}
		},
		'ongoing' : function () {
			let amountTotal = 0
			for(var i = 0 ; i < this.ongoing.length ; i++) {
				let amount = parseFloat(this.ongoing[i].amount)
				let price = parseFloat(this.ongoing[i].price_per_item)

				amountTotal += (amount * price)
			}
			this.form.amount = this.numberWithCommas(amountTotal)
		},
		'jasaLength' : {
			deep : true,
			handler () {
				let amountTotal = 0
				for(var i = 0 ; i < this.jasaLength.length ; i++) {
					let amount = parseFloat(this.jasaLength[i].amount.split(',').join(''))
					// let price = parseFloat(this.ongoing[i].price_per_item)

					amountTotal += amount
				}
				this.form.amount = this.numberWithCommas(amountTotal)
			}
		},
		'form.workorder_code' : function () {
			if(this.form.category == 'supplier_derek' && this.form.workorder_code) {
				this.loadCostDerek()
			}
			
		}
	},
	created () {
		this.debouceFunction = debounce((query) => {
			this.woList = [{
				name : 'Loading.....',
				form_code : 'Loading.....'
			}]
			this.loadWorkOrder(query)
		} , 
		1000)
	},
	mounted () {
        // this.getListOfWorkOrder();
        // this.getTaxPayable();
		this.loadSupplierList()
	},
	methods : {
		cancelBahan(token = null , transaction_id = null , sparepart_id = null) {
			let prevToken = "";

			if (token) {
				prevToken = this.$http.defaults.headers.common["Authorization"];

				this.$http.defaults.headers.common["Authorization"] =
					"Bearer " + token;
			}

			if(!transaction_id) transaction_id = this.temp.transaction_id
			else this.temp.transaction_id = transaction_id

			if(!sparepart_id) sparepart_id = this.temp.sparepart_id
			else this.temp.sparepart_id = sparepart_id

			this.$http
				.get("/api/v1/check")
				.then((resp) => {
					let data = resp.data.data;
					let super_user = data.is_superuser;

					if (super_user) {
						this.allowCancelBahan(token, prevToken , transaction_id , sparepart_id);
					} else {
						this.modal.showAdminAuth = true;
						this.reason = token
							? "Akun tersebut tidak punya access untuk fitur ini. Mohon dicoba dengan Akun lainnya."
							: "Untuk Memakai Fitur Batalakan Bahan, Diperlukan Otorisasi Administrator.";
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
		allowCancelBahan (token, prevToken , transaction_id, sparepart_id) {

			if(!transaction_id) transaction_id = this.temp.transaction_id
			else this.temp.transaction_id = transaction_id

			if(!sparepart_id) sparepart_id = this.temp.sparepart_id
			else this.temp.sparepart_id = sparepart_id

			this.modal.showAdminAuth = false;

			this.$store.dispatch("triggerAlert", [
				true,
				"Admin Permission Success",
			]);

			// let transaction_id = parseInt(transaction_id)
			this.$http.delete(`/api/v1/treasury/cancel-bahan?transaction_id=${transaction_id}&sparepart_id=${sparepart_id}`)
			.then((resp) => {
				this.$store.dispatch('triggerAlert' , [true, 'Bahan Berhasil dibatalkan.'])
				this.loadVoucherBahan(this.form.supplier_id);

				if (token) {
					this.$http.defaults.headers.common["Authorization"] = prevToken;
				}
			})
			.catch((err) => {
				this.$store.dispatch('triggerAlert' , [false , 'Pembatalan Gagal'])
				console.log(err)
			})

			// delete all inventory transaction with transaction_id parameter;
			// delete transaction_id in transactions with transaction_id and transaction_id + 1

		},
		addRemove(sparepart) {
			let index = this.ongoing.indexOf(sparepart)
			if(index == -1) {
				this.ongoing.push(sparepart)
			}
			else {
				this.ongoing.splice(index , 1)
			}
		},
		async loadCostDerek () {
			let workOrderCode = this.form.workorder_code


			this.$http.get('/api/v1/estimations/derek/cost?work_order_code=' + workOrderCode)
			.then((resp) => {
				// console.log(resp.data.data)
				// this.form.amount = parseFloat(resp.data.data)
				let data = resp.data.data[0]

				this.form.amount = this.numberWithCommas(parseFloat(data.sum_cost))

				if(data.voucher_created) {
					this.warning = 'Work Order tersebut sudah pernah bikin Supplier Voucher. Mohon Pilih Work Order yang lain.'
				}
				else {
					this.warning = null
				}
			})
			.catch((err) => {
				console.log(err);
			})
		},
		async loadWorkOrder (search = null) {
			// this.woList = [];

			let queryParam = ''

			if(search) {
				queryParam += `&search=${search}`
			}

			console.log(queryParam)

			this.$http.get('/api/v1/masterData/workorder?pagination=false&order=DESC&by=created_at' + queryParam)
			.then((resp) => {
				// this.woList = resp.data.data
				this.$set(this , 'woList' , resp.data.data)

				for(var i = 0 ; i < this.woList.length ; i++) {
					this.woList[i].name = this.woList[i].form_code + ' - ' + this.woList[i].no_polisi + ' - ' + this.woList[i].car_name
				}
				// console.log(this.woList)
			})
			.catch((err) => { console.log(err) })
		},
		addJasa (jasa){
			this.jasaLength.push(jasa)
		},
		loadSupplierList () {
			let type = ''
			this.form.category == 'supplier_part' ? type =  'P' : this.form.category == 'supplier_bahan' ? type = 'B' : type = 'J'

			if(type == 'J'){
				this.supplierList = this.options.supplier
				return
			}
				
			else {
				this.$http.get(`/api/v1/purchase-order/supplier-voucher/supplier-list?type=${type}`)
				.then((resp) => {
					this.supplierList = resp.data.data
				})
				.catch((err) => {
					console.log(err)
					this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong. Please Try Again Later.'])
				})
			}
			
			
		},
		clickAll() {
			if(this.pending_payment_bahan)
				this.ongoing = JSON.parse(JSON.stringify(this.pending_payment_bahan))
			else {
				this.ongoing = []
				let keys = Object.keys(this.pending_payment)
				for(var i = 0 ; i < keys.length ; i++) {
					for(var j = 0 ; j < this.pending_payment[keys[i]].length ; j++) {
						this.ongoing.push(this.pending_payment[keys[i]][j])
					}
				}
			}
		},
		reset() {
			this.ongoing = []
		},
		showImage (imagesList) {
			this.imagesList = imagesList
			this.modal.showImage = true
		},
		loadVoucherBahan (supplier_id) {
			this.$http.get(`/api/v1/purchase-order/supplier-voucher/bahan?supplier_id=${supplier_id}`)
			.then((resp) => {
				this.pending_payment_bahan = resp.data.data

				let pending_payment_bahan = resp.data.data
				let newObj = {}

				for(var i = 0 ; i < pending_payment_bahan.length ; i++) {
					// console.log(pending_payment_bahan[i])
					let dateReceived = pending_payment_bahan[i].date_received

					!newObj[dateReceived] ? newObj[dateReceived] = [pending_payment_bahan[i]] : newObj[dateReceived].push(pending_payment_bahan[i])
				}

				console.log(newObj)

				this.showPendingBahan = newObj
				this.full_pending_payment_bahan = resp.data.data
			})
			.catch((err) => {
				console.log(err)
				this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong. Please Try Again Later.'])
			})
		},
		loadVoucher (supplier_id) {
			this.$http.get(`/api/v1/purchase-order/supplier-voucher?supplier_id=${supplier_id}`)
			.then((resp) => {
				let pending_payment = resp.data.data
				let newObj = {}

				for(var i = 0 ; i < pending_payment.length ; i++) {

					let ppn = pending_payment[i].ppn_included

					let without_ppn = pending_payment[i].without_ppn

					if(ppn == 0 && !without_ppn) {
						pending_payment[i].price_per_item = parseFloat(pending_payment[i].price_per_item) * 1.1
						
					}

					pending_payment[i].estimation_price = (parseFloat(pending_payment[i].price_per_item) + parseFloat(pending_payment[i].markup ? pending_payment[i].markup : 0)) *  parseFloat(pending_payment[i].amount) - parseFloat(pending_payment[i].dp ? pending_payment[i].dp : 0)



					if(!pending_payment[i].time_of_arrival) {
						pending_payment[i].aging = '-'
					}
					else {
						let b = moment(pending_payment[i].time_of_arrival)
						let a = moment()

						var years = a.diff(b, 'year');
						b.add(years, 'years');

						var months = a.diff(b, 'months');
						b.add(months, 'months');

						var days = a.diff(b, 'days');

						pending_payment[i].aging = `${years > 0 ? years + ' T' : ''} ${months > 0 ? months + ' B' : ''} ${days > 0 ? days + ' H' : ''}`
					}
					
					if(pending_payment[i].delivery_photo){
						if(pending_payment[i].delivery_photo.includes(',')) {
							pending_payment[i].delivery_photo = pending_payment[i].delivery_photo.split(',')
							for(var j = 0 ; j < pending_payment[i].delivery_photo.length ; j++) {
								if(!pending_payment[i].delivery_photo[j].includes(env.baseImage))
									pending_payment[i].delivery_photo[j] = env.baseImage + '/' + pending_payment[i].delivery_photo[j]
							}
						}
						else {
							pending_payment[i].delivery_photo = [env.baseImage + '/' + pending_payment[i].delivery_photo]
						}
					}
					else {
						pending_payment[i].delivery_photo = []
					}
					

					!newObj[pending_payment[i].form_code + ' - ' + pending_payment[i].registration + ' - ' + pending_payment[i].car_name] ? newObj[pending_payment[i].form_code + ' - ' + pending_payment[i].registration + ' - ' + pending_payment[i].car_name] = [pending_payment[i]] : newObj[pending_payment[i].form_code + ' - ' + pending_payment[i].registration + ' - ' + pending_payment[i].car_name].push(pending_payment[i])
				}
				this.pending_payment = newObj
				this.full_pending_payment = resp.data.data
			})
			.catch((err) => {
				console.log(err)
			})
		},
        isRequired (field) {
            return (this.requiredFields[this.form.category].indexOf(field) !== -1) ? true : false
        },
        resetForm () {
            for (var i in this.form) {
                if (
                    i !== 'category' &&
                    i !== 'month' &&
                    i !== 'year' &&
                    i !== 'value_payable'
                ) this.form[i] = ''
            }

			this.pending_payment = null
			this.ongoing = null
        },
        async evaluateForm () {
            let errors = []
            let keys = this.requiredFields[this.form.category];

            //Check valid
            for(var i in keys) {
				if(keys[i] == 'proof_img') {
					if(!this.file) {
						errors.push('Harap Pilih Gambar Faktur Pembayaran Terlebih Dahulu.')
					}
					else {
						let image = await this.uploadImage()
						this.form.proof_img = image
					}
				}
				else if(this.form[keys[i]] == '' || this.form[keys[i]] == null) {
					errors.push(`${this.translate(keys[i])} Wajib Dipilih Atau Diisi`)
				}
            }

            //If any error is detected
            if (errors.length > 0) {
                this.$store.dispatch('triggerAlert', [false, errors]);
                return null;
            }

            //Create object for 'form', get all it's keys
            let data = JSON.parse(JSON.stringify(this.form));
            let formKeys = Object.keys(this.form);

            //Cleanse commas(,) on number fields
            for (var i in this.numberFields) data[this.numberFields[i]] = parseFloat(data[this.numberFields[i]].split(',').join(''))

            //Cleanse form field where it is not needed
            for (var i in formKeys) if (keys.indexOf(formKeys[i]) === -1) delete data[formKeys[i]];

            return data;

        },
		async submit() {
            //If tax payable, refer to another function
            if (this.form.category == 'tax_payable') {
                this.commitTaxTransaction();
                return;
            }
			
			if(this.form.category == 'supplier_cat'){
				this.$refs.supplier_cat.submitData()
				return
			}


		    let form = await this.evaluateForm()

            //Error detected
            if (!form) return;

			if(this.form.category == 'supplier_part') {
				this.commitSupplierPayment(form)
				return
			}
			else if (this.form.category == 'supplier_bahan') {
				this.commitSupplierBahanPayment(form)
				return
			}

			else if (this.form.category == 'supplier_jasa') {
				this.commitSupplierJasaPayment(form)
				return
			}

			else if (this.form.category == 'supplier_derek') {
				this.commitSupplierDerekPayment(form)
				return
			}

        },
		async getLastIndex (supplier_id , type) {
			try {
				let response = await this.$http.post('/api/v1/treasury/supplier-voucher/index?supplier_id=' + supplier_id , {type : type})
				// console.log(response)
				return response.data.data.sv_id	
			}
			catch(err) {
				this.$store.dispatch('triggerAlert' , [false , 'Something Went Wrong in Fetching Supplier Code. Please Try Again Later.'])
				console.log(err)
			}
		},
		async commitSupplierDerekPayment (form) {

			// console.log(form)
			// let length = this.ongoing.length;
			// let counter = 0;

			let svCounter = await this.getLastIndex(this.form.supplier_id , 'DEREK')

			if(!svCounter) return

			let data = {}

			// // console.log(this.jasaLength)

			data.sparepart_data = [{
				amount : form.amount,
				sv_id : svCounter,
				work_order_code : this.form.workorder_code
			}]
			// // console.log(data.sparepart_data)

			this.$http.post(`/api/v1/treasury/insert-voucher-estimations` , data)
			.then((resp) => {
				this.$store.dispatch('triggerAlert', [true, `Supplier Voucher Berhasil Dibikin`]);
				this.resetForm();
				this.loadSupplierList()
				this.ongoing = []

				this.$router.push({ name : 'SupplierVoucher'})
			})
			.catch((err) => {
				console.log(err)
			})

		},
		async commitSupplierJasaPayment (form) {
			let length = this.ongoing.length;
			let counter = 0;

			let svCounter = await this.getLastIndex(this.form.supplier_id , 'JASA')

			if(!svCounter) return

			let data = {}

			// console.log(this.jasaLength)

			data.sparepart_data = this.jasaLength.map( x => (  { 
				sparepart_id : x.sparepart_id,
				estimation_id : x.estimation_id ? x.estimation_id : null,
				amount : parseFloat(x.amount.split(',').join('')),
				sv_id : svCounter,
				work_order_code : x.work_order_code
			}))
			// console.log(data.sparepart_data)

			this.$http.post(`/api/v1/treasury/insert-voucher-estimations` , data)
			.then((resp) => {
				if(length == counter)
					this.$store.dispatch('triggerAlert', [true, `Supplier Voucher Berhasil Dibikin`]);
				else
					counter++
				this.resetForm();
				this.loadSupplierList()
				this.ongoing = []

				this.$router.push({ name : 'SupplierVoucher'})
			})
			.catch((err) => {
				console.log(err)
			})

		},
		async commitSupplierBahanPayment (form) {
			let length = this.ongoing.length;
			let counter = 0;

			let svCounter = await this.getLastIndex(this.form.supplier_id , 'BAHAN')

			if(!svCounter) return

			let data = {}

			data.sparepart_data = this.ongoing.map( x => (  { 
				sparepart_id : x.sparepart_id,
				estimation_id : x.estimation_id ? x.estimation_id : null,
				amount : parseFloat(x.price_per_item) * parseFloat(x.amount),
				sv_id : svCounter,
				transaction_id : x.transaction_id
			}))

			this.$http.post(`/api/v1/treasury/insert-voucher-estimations` , data)
			.then((resp) => {
				if(length == counter)
					this.$store.dispatch('triggerAlert', [true, `Supplier Voucher Berhasil Dibikin`]);
				else
					counter++
				this.resetForm();
				this.loadSupplierList()
				this.ongoing = []

				this.$router.push({ name : 'SupplierVoucher'})
			})
			.catch((err) => {
				console.log(err)
			})

		},
		async commitSupplierPayment(form) {
			let length = this.ongoing.length;
			let counter = 0;

			let svCounter = await this.getLastIndex(this.form.supplier_id , 'PART')

			if(!svCounter) return

			let data = {}

			data.sparepart_data = this.ongoing.map( x => (  { 
				sparepart_id : x.sparepart_id,
				estimation_id : x.estimation_id ? x.estimation_id : undefined,
				amount : parseFloat(x.price_per_item) * parseFloat(x.amount),
				sv_id : svCounter
			}))
			

			this.$http.post(`/api/v1/treasury/insert-voucher-estimations` , data)
			.then((resp) => {
				if(length == counter)
					this.$store.dispatch('triggerAlert', [true, `Supplier Voucher Berhasil Dibikin`]);
				else
					counter++
				this.resetForm();
				this.$router.push({ name : 'SupplierVoucher'})
			})
			.catch((err) => {
				console.log(err)
			})
			
		},

		translate (word) {
            let dictionary = {
                category : 'Kategori',
                workorder_code : 'Work Order',
                sparepart_id : 'Sparepart',
                supplier_id : 'Supplier',
                labourer_id : 'Pekerja',
                description : 'Deskripsi',
                salary : 'Gaji',
                overtime : 'Lembur',
                bonus : 'Bonus',
                amount : 'Jumlah Uang',
                proof_img : 'Gambar Faktur Pembayaran',
            }

			return dictionary[word]
        },
	}
}
</script>

<style>
	.middleDiv {
		margin-top: auto;
		margin-bottom: auto;
	}
</style>